export const CURRENT_SUBSECTION_ID = 'CURRENT_SUBSECTION_ID';
export const SET_CURRENT_SUBSECTION_ID = 'SET_CURRENT_SUBSECTION_ID';
export const SECTIONS_COLLAPSED = 'SECTIONS_COLLAPSED';
export const SET_SECTIONS_COLLAPSED = 'SET_SECTIONS_COLLAPSED';
export const COLLAPSE_SECTIONS_LANGS = 'COLLAPSE_SECTIONS_LANGS';
export const SET_COLLAPSE_SECTIONS_LANGS = 'SET_COLLAPSE_SECTIONS_LANGS';
